import * as React from 'react';
import { useState, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { SecurityAppSecurityEvents } from '@graylog/enterprise-api';

import type { FilterComponentProps } from 'stores/PaginationTypes';
import SuggestionsList from 'components/common/EntityFilters/FilterConfiguration/SuggestionsList';
import usePluginEntities from 'hooks/usePluginEntities';

const DEFAULT_SEARCH_PARAMS = {
  query: '',
  pageSize: 10,
  page: 1,
};

const EventDefinitionTypeFilter = ({
  attribute,
  allActiveFilters,
  filter,
  filterValueRenderer,
  onSubmit,
}: FilterComponentProps) => {
  const [filterQuery, setFilterQuery] = useState(DEFAULT_SEARCH_PARAMS);
  const eventDefinitionTypes = usePluginEntities('eventDefinitionTypes');

  const fetchEventDefinitionTypes = () =>
    SecurityAppSecurityEvents.getFilterOptions({
      fields: ['event_definition_type'],
      timerange: 30 * 86400,
    }).then((resp) =>
      resp.event_definition_type.map((entry) => ({
        id: entry,
        value: eventDefinitionTypes.find((edt) => edt.type === entry)?.displayName ?? entry,
      })),
    );

  const { data: _suggestions, isInitialLoading } = useQuery({
    queryKey: ['security_events', 'event_definition_types'],
    queryFn: fetchEventDefinitionTypes,
  });

  const suggestions = useMemo(
    () =>
      _suggestions
        ? [..._suggestions.filter((suggestion) => suggestion.value.toLowerCase().includes(filterQuery.query))]
        : _suggestions,
    [_suggestions, filterQuery],
  );

  return (
    <SuggestionsList
      allActiveFilters={allActiveFilters}
      attribute={attribute}
      filter={filter}
      filterValueRenderer={filterValueRenderer}
      onSubmit={onSubmit}
      suggestions={suggestions}
      isLoading={isInitialLoading}
      total={suggestions?.length}
      page={1}
      pageSize={suggestions?.length}
      setSearchParams={setFilterQuery}
    />
  );
};

export default EventDefinitionTypeFilter;
